import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { WaybillEquipmentsModel } from '../../../../models/waybill-equipments.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderEquipmentsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderTransportEquipments(
    transportOrderIdView: TransportOrderIdView,
  ): Observable<WaybillEquipmentsModel> {
    return this.http.get<WaybillEquipmentsModel>(
      `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
        ShipmentTransportOrderEndpoint.Equipments
      }?${getQueryStringFromObject(transportOrderIdView)}`,
    );
  }
}
